(function () {

  const dataTarget = document.currentScript.getAttribute('data-target')
  const testimonialContainer = document.querySelector(dataTarget)
  if(!testimonialContainer) return
  const testimonialSwiper = testimonialContainer.querySelector('.testimonial__swiper')
  const testimonialScrollbar = testimonialContainer.querySelector('.swiper-scrollbar');
  
  const swiper = new Swiper(testimonialSwiper, {
    // Optional parameters
    direction: 'vertical',
    slidesPerView: "auto",
    centeredSlides: true,
    initialSlide: 1,
    centeredSlidesBounds: true,

    scrollbar: {
      el: testimonialScrollbar,
      draggable: true,
    },
    breakpoints: {
      768: {
        spaceBetween: 30,
      },
      0: {
        spaceBetween: 20,
      },
    },
  });
})();
